import React from 'react';
import { Link } from 'react-router-dom';

// Minnow School Logo - Simple fish design
// Navy blue (#0b2545) fish, orange (#ff8c00) tail
export const MinnowLogo = ({ variant = 'blue', className = '', size = 40 }) => {
  const fishColor = variant === 'white' ? '#FFFFFF' : '#0b2545';
  const tailColor = '#ff8c00'; // Bright orange
  
  return (
    <svg 
      width={size * 2} 
      height={size} 
      viewBox="0 0 100 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Orange tail - simple V shape */}
      <path 
        d="M65 25 L95 5 L80 25 L95 45 Z" 
        fill={tailColor}
      />
      
      {/* Fish body - simple oval */}
      <ellipse 
        cx="38" 
        cy="25" 
        rx="33" 
        ry="20" 
        fill={fishColor}
      />
      
      {/* Fish eye - white/contrasting dot */}
      <circle 
        cx="22" 
        cy="22" 
        r="5" 
        fill={variant === 'white' ? '#0b2545' : '#FFFFFF'}
      />
      <circle 
        cx="23" 
        cy="21" 
        r="2" 
        fill={fishColor}
      />
    </svg>
  );
};

// Full logo with wordmark - clickable
export const MinnowLogoFull = ({ variant = 'blue', logoSize = 40, className = '', linkTo = '/' }) => {
  const textColor = variant === 'white' ? 'text-white' : 'text-[#0b2545]';
  
  return (
    <Link to={linkTo} className={`flex items-center gap-3 hover:opacity-90 transition-opacity ${className}`}>
      <MinnowLogo variant={variant} size={logoSize} />
      <span className={`text-xl font-bold ${textColor}`}>Minnow School</span>
    </Link>
  );
};

// Just the logo, clickable
export const MinnowLogoLink = ({ variant = 'blue', size = 40, className = '', linkTo = '/' }) => {
  return (
    <Link to={linkTo} className="hover:opacity-90 transition-opacity">
      <MinnowLogo variant={variant} size={size} className={className} />
    </Link>
  );
};

export default MinnowLogo;
